<h1>Classified Routing Test</h1>
<div class="navLinks">
  <ul>
  <li><a [routerLink]="['/home']">Home</a></li>
  <li><a [routerLink]="['/encoding']">Encoding</a></li>
  <li><a [routerLink]="['/dashboard']">Dashboard</a></li>
  </ul>
</div>
<router-outlet></router-outlet>
